import React from 'react';
import Add_Marks from './Add_Marks';
import '../../../CommonCSS/SocietyCSS.css'

const Add_MarksApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> Marks Entry</h5>
          </div>  
        </div>
        <Add_Marks/>
      </div>
    </div >
  );
};

export default Add_MarksApp;
